/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import GraphFilter from './FilterNodes';
import GraphLayoutControls from './LayoutControls';
import SpacingFactorControl from './SpacingControl';
import FullscreenToggle from './FullscreenToggle';
import KHopFilter from './KTopFilter';
import { ToolbarWrapper } from '../../gallery/styles';

type GraphToolbarProps = {
  cy: any;
  layoutName: any;
  setLayoutName: (next: any) => void;
  kHop: number;
  setKHop: (k: number) => void;
  applyKHop: (k: number) => void;
  clearKHop: () => void;
  isFullscreen: boolean;
  toggleFullscreen: () => Promise<void> | void;
  mode: string;
};

const GraphToolbar: React.FC<GraphToolbarProps> = ({
  cy,
  layoutName,
  setLayoutName,
  kHop,
  setKHop,
  applyKHop,
  clearKHop,
  isFullscreen,
  toggleFullscreen,
  mode
}) => {
  return (
    <ToolbarWrapper mode={mode}>
      <ToolbarComponent overflowMode="Scrollable">
        <ItemsDirective>
          <ItemDirective template={() => <GraphFilter cy={cy} />} />
          <ItemDirective
            template={() => (
              <GraphLayoutControls
                cy={cy}
                initialLayoutName={layoutName}
                currentLayoutName={layoutName}
                onLayoutChange={setLayoutName}
              />
            )}
          />
          <ItemDirective
            template={() => (
              <SpacingFactorControl cy={cy} min={0.3} max={3} step={0.01} />
            )}
          />
          <ItemDirective
            template={() => (
              <KHopFilter
                k={kHop}
                onKChange={setKHop}
                onApply={applyKHop}
                onClear={clearKHop}
              />
            )}
          />
          {/* <ItemDirective template={() => (
            <CollisionToggle active={avoidOverlap} onToggle={toggleAvoidOverlap} />
          )} /> */}
          <ItemDirective
            template={() => (
              <FullscreenToggle isFullscreen={isFullscreen} onToggle={toggleFullscreen} />
            )}
          />
        </ItemsDirective>
      </ToolbarComponent>
    </ToolbarWrapper>
  );
};

export default GraphToolbar;
